import awsconfig from 'aws-exports'

export const apiName = awsconfig.aws_cloud_logic_custom[0].name
